import { SET_SIZE } from './types';

const actions = {
  setSize({ commit }, w) {
    commit(SET_SIZE, w);
  }
};

export default actions;
